/**
 * Selected-account store — the global account filter for the account-scoped
 * modules (Portfolio Dashboard, Auto-Schedule, Resources & Calendar, Workload
 * & Capacity). `accountId === null` means "All accounts" (portfolio-wide).
 *
 * Persisted to localStorage so the choice survives a refresh AND a sign-out —
 * it is deliberately NOT cleared on logout (unlike the in-memory auth store),
 * so the next session lands on the same account the user last looked at.
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SelectedAccountState {
  /** Currently-filtered account, or null for the portfolio-wide view. */
  accountId: string | null;
  setAccountId: (accountId: string | null) => void;
}

export const useSelectedAccount = create<SelectedAccountState>()(
  persist(
    (set) => ({
      accountId: null,
      setAccountId: (accountId) => set({ accountId }),
    }),
    { name: 'manage-selected-account' },
  ),
);
